import { render, staticRenderFns } from "./FightReportTrainerMini.vue?vue&type=template&id=a4c9d03c&scoped=true"
import script from "./FightReportTrainerMini.vue?vue&type=script&lang=js"
export * from "./FightReportTrainerMini.vue?vue&type=script&lang=js"
import style0 from "./FightReportTrainerMini.vue?vue&type=style&index=0&id=a4c9d03c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c9d03c",
  null
  
)

export default component.exports